import { styleConstants } from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface InsetOptionProps {
  className?: string
  onClick?: () => void
}

const InsetOption: React.FC<React.PropsWithChildren<InsetOptionProps>> = (
  props,
): React.ReactElement => {
  return (
    <div
      css={css`
        background-color: ${styleConstants.colors.gray_lightest};
        padding: 16px 20px;
        border-radius: ${styleConstants.borderRadius.box};
        border: 1px solid ${styleConstants.colors.gray_medium};
        min-height: 70px;
      `}
      className={props.className}
      onClick={props.onClick}
      onKeyPress={props.onClick}
      role="button"
      tabIndex={0}
    >
      {props.children}
    </div>
  )
}

export default InsetOption
